import twire from './twire';


/**
 * One-tune functions to do things to the DOM, etc
 */
export const initScopedDOM = (container = document) => {

	const $container = $(container);

	// Run twire functions
	twire.init(container);

	// External links
	$container.find('a[href^="http://"], a[href^="https://"]')
			  .each((i, el) => {

		const isExternal = el.host !== window.location.host;

		if (isExternal) {

			$(el).attr({

				'target': '_blank',
				'rel': 'noopener noreferrer'

			});

		}

	});

	// Button icons
	$('form button, a.button').each((i, el) => {

		var $this = $(el);

		let icon = 'right';
		let func = 'append';

		if ($this.data('button-type') == 'prev') {

			icon = 'left';
			func = 'prepend';

		} else if ($this.data('button-type') == 'up') {

			icon = 'up';

		}

		$this[func]('<span class="icon"><span class="bi bi-arrow-' + icon + '"></span></span>');

	})

};